import React from 'react'

import { injectIntl, WrappedComponentProps } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'

import { SubmissionTextThumbnail } from '@components/BrandFans/InfluencerIdentity/Row/Submissions/TextThumbnail'
import Image from '@components/UI/Image'
import { AspectRatios, SocialSubmissionTypes } from '@enums'
import { FadeIn } from '@lib/effects'
import { IApplicationState } from '@store'
import {
  selectGlyphIcon,
  selectMediaThumbnail,
  selectSocialSubmissionType,
  selectTranslatedTooltipText,
} from '@store/submissions'
import Theme from '@theme'
import { Icon } from '@tribegroup'
import {
  ThumbnailImageIconWrapper,
  ThumbnailImageOverlay,
  ThumbnailImageWrapper,
} from './Image.styled'

interface ISubmissionThumbnailImageProps {
  submissionId: number
}

const SubmissionThumbnailImage: React.FC<
  ISubmissionThumbnailImageProps & WrappedComponentProps
> = ({ submissionId, intl }) => {
  const { socialSubmissionType, mediaUrl, iconGlyph, tooltipText } = useSelector(
    (state: IApplicationState) => ({
      mediaUrl: selectMediaThumbnail(state, submissionId),
      iconGlyph: selectGlyphIcon(state, submissionId),
      tooltipText: selectTranslatedTooltipText(state, submissionId, intl),
      socialSubmissionType: selectSocialSubmissionType(state, submissionId),
    }),
    shallowEqual,
  )
  const isTextSocialSubmission = socialSubmissionType === SocialSubmissionTypes.Text
  return (
    <ThumbnailImageWrapper data-tooltip-content={tooltipText} data-tooltip-id="base-tooltip">
      {isTextSocialSubmission ? (
        <SubmissionTextThumbnail />
      ) : (
        <Image
          src={mediaUrl}
          aspectRatio={AspectRatios.ONE_BY_ONE}
          animation={FadeIn}
          loadingColor={Theme.whiteColor}
          aria-label="Submission thumbnail"
        />
      )}
      <ThumbnailImageOverlay />
      {iconGlyph && (
        <ThumbnailImageIconWrapper>
          <Icon size={1.5} glyph={iconGlyph} color={Theme.whiteColor} />
        </ThumbnailImageIconWrapper>
      )}
    </ThumbnailImageWrapper>
  )
}

export { SubmissionThumbnailImage }
export default injectIntl(SubmissionThumbnailImage)
